/* eslint-disable no-multi-assign,class-methods-use-this,prefer-destructuring,no-restricted-syntax */

import $ from 'jquery';
import _ from 'lodash';

const INSTANCE_IDENTIFIER = '_layoutSizeListener';

export class LayoutSizeListener {
  static bind(callback) {
    const instance = (window[INSTANCE_IDENTIFIER] =
      window[INSTANCE_IDENTIFIER] || new LayoutSizeListener());
    instance._attachListener(callback);
  }

  static unbind(callback) {
    const instance = window[INSTANCE_IDENTIFIER];
    if (instance) {
      instance._callbacks.delete(callback);
      if (instance._callbacks.size === 0) {
        instance.deactivate();
      }

      if (instance.size === 0) {
        instance.destroy();
      }
    }
  }

  constructor() {
    this._callbacks = new Set();
  }

  activate = () => {
    let oldLayout = this._layout();
    this.intervalId = setInterval(() => {
      const newLayout = this._layout();
      if (!_.isEqual(newLayout, oldLayout)) {
        oldLayout = newLayout;
        this._runCallbacks();
      }
    }, 200);
    $(window).on(
      this._nsEventNames('resize', 'orientationchange', 'scroll'),
      this._runCallbacks
    );
    $('body').on(
      this._nsEventNames(
        'chat-expanded',
        'chat-collapsed',
        'create-page-modal-changed',
        'block-page-mode-changed'
      ),
      this._runCallbacks
    );
  };

  deactivate = () => {
    clearInterval(this.intervalId);
    this.intervalId = null;
    $(window).off(
      this._nsEventNames('resize', 'orientationchange', 'scroll'),
      this._runCallbacks
    );
    $('body').off(
      this._nsEventNames(
        'chat-expanded',
        'chat-collapsed',
        'create-page-modal-changed',
        'block-page-mode-changed'
      ),
      this._runCallbacks
    );
  };

  destroy() {
    clearInterval(this.intervalId);
    $(window).off(`.${INSTANCE_IDENTIFIER}`);
    $('body').off(`.${INSTANCE_IDENTIFIER}`);
    delete window[INSTANCE_IDENTIFIER];
  }

  _nsEventNames(...names) {
    return names.map((name) => `${name}.$INSTANCE_IDENTIFIER}`).join(' ');
  }

  _layout() {
    const body = document.body;
    const html = document.documentElement;
    const $firstPageContainer = $('.first-page-container');
    const $nonCoursePageContent = $('#non-course-page-content');
    const $pageContainer = $('.page-container');
    const $firstPageSection = $('.first-page-section');
    const $homepageContainer = $('#homepage-container');
    const $portalContainer = $('#portal-container');
    const $basePageContainer = $('#base-page-container');
    const $firstContainer = $firstPageContainer.length
      ? $firstPageContainer
      : $nonCoursePageContent.length
      ? $nonCoursePageContent
      : // On profile pages that do not display a course banner,
      // just use the first page-container
      $pageContainer.length
      ? $pageContainer.first()
      : $firstPageSection.length
      ? $firstPageSection.first()
      : $homepageContainer.length
      ? $homepageContainer
      : $portalContainer.length
      ? $portalContainer
      : $basePageContainer.length
      ? $basePageContainer
      : $('header');
    const firstContainerOffset = $firstContainer.offset();

    return {
      top: firstContainerOffset.top,
      left: firstContainerOffset.left,
      width: $firstContainer.length ? $firstContainer.outerWidth(true) : 0,
      height: Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      ),
    };
  }

  _attachListener = (callback) => {
    this._callbacks.add(callback);
    if (this._callbacks.size === 1) {
      this.activate();
    }
  };

  _runCallbacks = () => {
    for (const callback of this._callbacks) {
      callback();
    }
  };
}
